import { Layout } from '@uhg-abyss/web/ui/Layout';
import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
import CustomeRowAdd from '../CustomeRowAdd';
import { useDispatch, useSelector } from 'react-redux';
import { DestinationCheck } from '@src/constants';
import React, { useState } from 'react';
import { setForm } from '@src/store/slices/ListofValuesSlice';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { capitalizeFirstLetter } from '@src/utils';

const AddThresholdProcessing = () => {
  const dropDownData = useSelector((state) => state?.listOfValues?.data);
  const router = useRouter();
  const form = useForm();

  const { thresholdValues, autoCancelIndicators, thresholdTypes } =
    dropDownData;
  const listAndDestination = useSelector((state) => state);
  const { destinationSystem, listOfValues }: any = listAndDestination;
  const systemType = destinationSystem.data;

  const isGPSorPRIME =
    systemType === DestinationCheck.GPS ||
    systemType === DestinationCheck.PRIME;
  const isPrime = systemType === DestinationCheck.PRIME;

  const handleChange = (i, thresholdType, e) => {
    form.setValue(
      `thresholdProcessing.percentages[${i}].thresholdType`,
      thresholdType
    );
    form.setValue(
      `thresholdProcessing.percentages[${i}].thresholdPercentage`,
      e
    );
  };
  const thresholds = form.watch('thresholdProcessing.percentages');
  const dsystem = form.watch('customerDetails.destinationSystem');
  const isCopy = router?.getLocation()?.pathname?.includes('/copy');
  const indexedThresholds = thresholds?.map((value, index) => ({
    index,
    ...value,
  })) ?? [];
  const customOrder = [
    'ADD',
    'DEMOGRAPHICS',
    'TERMINATION',
    'CHANGE',
    'ERROR',
    'ADDRESS',
    'COVERAGE',
  ];
  const getLabel = (value) => {
    const type = thresholdTypes?.find(
      (type) => type?.value.trim() === value.trim()
    );
    return type ? type.label : 'UNKNOWN';
  };
  const getModel = (label) => {
    const index = indexedThresholds.findIndex(
      (threshold) => getLabel(threshold?.thresholdType) === label
    );
    if (index !== -1) {
      return `thresholdProcessing.percentages[${index}].thresholdPercentage`;
    } else {
      // Add a new threshold type if it doesn't exist
      const newThreshold = {
        thresholdType: profileLists?.thresholdTypes.find(
          (type) => type.label === label
        )?.value,
        thresholdPercentage: 0,
      };
      indexedThresholds.push(newThreshold);
      form.setValue(
        `thresholdProcessing.percentages[${indexedThresholds.length - 1}]`,
        newThreshold
      );
      return `thresholdProcessing.percentages[${
        indexedThresholds.length - 1
      }].thresholdPercentage`;
    }
  };
  return (
    <Layout.Group
      css={{
        alignItems: 'start',
        '.abyss-table-cell': {
          paddingTop: '2px',
          paddingBottom: '2px',
        },
        '.abyss-select-input-container,.abyss-text-input': {
          minHeight: '26px',
          lineHeight: '0.9',
          borderRadius: '0',
        },
        '.abyss-select-input-root .abyss-layout-group,.abyss-text-input-root .abyss-layout-group':
          {
            display: 'none',
          },
        '.abyss-select-input-container-wrapper': {
          height: '26px',
          borderRadius: '0',
        },
      }}
      grow
    >
      <Table.Container title="">
        <Table.TableBody>
          <CustomeRowAdd
            label="Profile Population"
            type={isPrime ? 'empty' : ''}
            model="thresholdProcessing.submitterGroupPopulation"
            maxLength={7}
          />
          {isCopy ? (
            <>
              {customOrder.slice(0, 2).map((label, index) => (
                <CustomeRowAdd
                  key={index}
                  model={getModel(label)}
                  type={'selec'}
                  label={`Threshold ${capitalizeFirstLetter(label)} %`}
                  options={thresholdValues}
                />
              ))}
            </>
          ) : (
            <>
              <CustomeRowAdd
                label="Threshold Add %"
                model="thresholdProcessing[0].thresholdPercentage"
                type={'selec'}
                handleChange={(e) => handleChange(0, '1', e)}
                options={thresholdValues}
              />
              <CustomeRowAdd
                label="Threshold Demographics %"
                model="thresholdProcessing[1].thresholdPercentage"
                handleChange={(e) => handleChange(1, '2', e)}
                options={thresholdValues}
                type={'selec'}
              />
            </>
          )}
        </Table.TableBody>
      </Table.Container>
      <Table.Container title="">
        <Table.TableBody>
          <CustomeRowAdd
            label="Auto-Cancel Indicator"
            model="thresholdProcessing.autoCancelIndicator"
            options={autoCancelIndicators}
            type={isPrime ? 'empty' : 'select'}
          />
          {isCopy ? (
            <>
              {customOrder.slice(2, 4).map((label, index) => (
                <>
                  {label === 'CHANGE' &&
                  (dsystem === '8' || dsystem === 'G') ? (
                    <>
                      {' '}
                      <Table.Row css={{ height: '26px' }}>
                        <Table.Cell>
                          <strong>{`Threshold ${capitalizeFirstLetter(
                            label
                          )} %`}</strong>
                        </Table.Cell>
                        <Table.Cell></Table.Cell>
                      </Table.Row>
                    </>
                  ) : (
                    <CustomeRowAdd
                      key={index + 2}
                      model={getModel(label)}
                      label={`Threshold ${capitalizeFirstLetter(label)} %`}
                      options={thresholdValues}
                      type={'selec'}
                    />
                  )}
                </>
              ))}
            </>
          ) : (
            <>
              <CustomeRowAdd
                label="Threshold Termination %"
                model="thresholdProcessing[2].thresholdPercentage"
                type={'select'}
                options={thresholdValues}
                handleChange={(e) => handleChange(2, '16', e)}
              />
              <CustomeRowAdd
                label="Threshold Changes %"
                model="thresholdProcessing[3].thresholdPercentage"
                type={
                  systemType == '8' || systemType == 'G' ? 'empty' : 'select'
                }
                handleChange={(e) => handleChange(3, '64', e)}
                options={thresholdValues}
              />
            </>
          )}
        </Table.TableBody>
      </Table.Container>
      <Table.Container title="">
        <Table.TableBody>
          {isCopy ? (
            <>
              {customOrder.slice(4).map((label, index) => (
                <React.Fragment key={index}>
                  {label === 'ERROR' && dsystem === '5' ? (
                    <Table.Row css={{ height: '26px' }}>
                      <Table.Cell>
                        <strong>{`Threshold ${capitalizeFirstLetter(
                          label
                        )} %`}</strong>
                      </Table.Cell>
                      <Table.Cell></Table.Cell>
                    </Table.Row>
                  ) : (
                    <CustomeRowAdd
                      model={getModel(label)}
                      label={`Threshold ${capitalizeFirstLetter(label)} %`}
                      options={thresholdValues}
                      type={'selec'}
                    />
                  )}
                </React.Fragment>
              ))}
            </>
          ) : (
            <>
              <CustomeRowAdd
                label="Threshold Error %"
                type={isPrime ? 'empty' : 'select'}
                model="thresholdProcessing[4].thresholdPercentage"
                handleChange={(e) => handleChange(4, '32', e)}
                options={thresholdValues}
              />
              <CustomeRowAdd
                label="Threshold Address %"
                model="thresholdProcessing[5].thresholdPercentage"
                type={'select'}
                handleChange={(e) => handleChange(5, '4', e)}
                options={thresholdValues}
              />
              <CustomeRowAdd
                label="Threshold Coverage %"
                model="thresholdProcessing[6].thresholdPercentage"
                handleChange={(e) => handleChange(6, '8', e)}
                type={'select'}
                options={thresholdValues}
              />
            </>
          )}
        </Table.TableBody>
      </Table.Container>
    </Layout.Group>
  );
};

export default AddThresholdProcessing;
